import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useAuth } from '../../context/AuthContext';
import './AdminLayout.css';

const AdminLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const menuItems = [
    { path: '/admin', icon: '📊', label: 'Dashboard', exact: true },
    { path: '/admin/orders', icon: '📦', label: 'Orders', exact: false },
    {
      path: '/admin/components',
      icon: '🧩',
      label: 'Components',
      submenu: [
        { path: '/admin/components/bases', label: 'Bases' },
        { path: '/admin/components/shades', label: 'Shades' },
        { path: '/admin/components/colors', label: 'Colors' },
      ]
    },
    { path: '/admin/coupons', icon: '🎟', label: 'Coupons', exact: false },
    { path: '/admin/support', icon: '💬', label: 'Support', exact: false },
    { path: '/admin/settings', icon: '⚙', label: 'Settings', exact: false },
  ];

  const isActive = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="admin-sidebar-header">
          <h2 className="admin-logo">Kalpavriksha Admin</h2>
          <button 
            className="sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            aria-label="Toggle sidebar"
          >
            {sidebarOpen ? '◀' : '▶'}
          </button>
        </div>

        <nav className="admin-nav">
          {menuItems.map((item) => (
            <div key={item.path} className="nav-item-wrapper">
              <Link
                to={item.path}
                className={`nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
              >
                <span className="nav-icon">{item.icon}</span>
                {sidebarOpen && <span className="nav-label">{item.label}</span>}
              </Link>
              
              {item.submenu && sidebarOpen && isActive(item.path) && (
                <div className="submenu">
                  {item.submenu.map((subItem) => (
                    <Link
                      key={subItem.path}
                      to={subItem.path}
                      className={`submenu-item ${isActive(subItem.path, true) ? 'active' : ''}`}
                    >
                      {subItem.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          {sidebarOpen && (
            <div className="admin-user-info">
              <div className="admin-avatar">
                {user?.name?.charAt(0)?.toUpperCase() || 'A'}
              </div>
              <div className="admin-user-details">
                <div className="admin-user-name">{user?.name || 'Admin'}</div>
                <div className="admin-user-email">{user?.email || ''}</div>
              </div>
            </div>
          )}
          <button className="admin-logout-btn" onClick={handleLogout}>
            <span className="logout-icon">🚪</span>
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className={`admin-main ${!sidebarOpen ? 'sidebar-closed' : ''}`}>
        <header className="admin-header">
          <div className="admin-header-content">
            <h1 className="admin-page-title">
              {location.pathname === '/admin' && 'Dashboard'}
              {location.pathname.startsWith('/admin/orders') && 'Orders'}
              {location.pathname.startsWith('/admin/components') && 'Product Components'}
              {location.pathname.startsWith('/admin/coupons') && 'Coupons'}
              {location.pathname.startsWith('/admin/support') && 'Support Tickets'}
              {location.pathname.startsWith('/admin/settings') && 'Settings'}
            </h1>
            <div className="admin-header-actions">
              <Link to="/" className="view-site-btn">
                View Site →
              </Link>
            </div>
          </div>
        </header>

        <div className="admin-content">
          {children}
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;

